
const German = {
    "form.isRequired": "{name} ist erforderlich!",
    "form.OTPLabel": "E-Mail-Bestätigungscode",
    "form.OTPInputValidMessage": "Erfolgreich",
    "form.OTPInputInvalidMessage": "Falscher OTP",
    "form.OTPWaitSecondsLabel": "Erneut senden ({waitOtpSeconds}s)",
    "form.OTPSendLabel": "OTP senden",
    "form.OTPSendSuccessLabel": "Der Bestätigungscode wurde erfolgreich an Ihre E-Mail-Adresse gesendet!",
    "form.OTPTips": "Bitte geben Sie einen gültigen OTP ein.",
    "form.selectInputLabel": "Suchen...",
    "form.uploadBtn": "HOCHLADEN",
    "form.uploadSizeTips": "Dateien müssen kleiner als 5 MB sein.",
    "form.uploadTypeTips": "Zulässige Dateitypen: png, gif, jpg, jpeg, pdf.",
    "form.uploadNumTips": "Es muss eine Datei hochgeladen werden.",
    "form.isRequiredAccept": "Sie müssen dies akzeptieren, um fortzufahren.",
    "form.sendButton": "SENDEN",
    "form.isEmail": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    "form.isSerialNumber": "Bitte geben Sie 13 Zeichen in {name} ein.",
    "form.categoryPlaceholder": "- Produktkategorie auswählen -",
    "form.seriesPlaceholder": "- Produktserie auswählen -",
    "form.skuPlaceholder": "- Modellnummer (SKU) -",
    "form.sendSuccessMsg": "Senden erfolgreich!",

    "warrantyPeriod.checkTitle": "Check Warranty Period",
    "warrantyPeriod.checkDescription": "Please enter your email and serial number to check the warranty period.",
    "warrantyPeriod.emailLabel": "Email",
    "warrantyPeriod.emailPlaceholder": "Enter Email",
    "warrantyPeriod.serialNumberLabel": "Serial Number",
    "warrantyPeriod.serialNumberPlaceholder": "Enter Serial Number",
    "warrantyPeriod.checkButton": "Check",
    "warrantyPeriod.sendSuccessfulLabel": "Send Successfully! please check your email",
    "warrantyPeriod.checkNoRecordLabel": "Sorry, no record was found!",
}
export {
    German
}   